import React from "react";
// import TLink from "../components/TLink";
import { checkPermission, checkTextTranslation, pathMaker } from "../utils/useful";
// import { siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import TabBarItem from "../components/boxes/TabBarItem";
import { withRouter } from "react-router-dom";
// import store from "../stores/storeConfig";
import HttpServices from "../utils/Http.services";

class TabBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tabs: [

                { name: '{{lang}}Dashboard', href: '/', key: 'home', icon: '/images/kheiry/dashboard.svg', page: '/' },

                // { name: '{{lang}}document', href: '/document', key: 'document', icon: '/images/icons/records.png', page: 'document', },

                // { name: '{{lang}}energy', href: '/energy', key: 'energy', icon: '/images/icons/booster.png', page: 'energy', commingSoon: false },

                // { name: '{{lang}}carbon', href: '/carbon', key: 'carbon', icon: '/images/icons/reduction.png', page: 'carbon', commingSoon: false },






                // { name: '{{lang}}services', href: '/services', key: 'services', icon: '/images/icons2/033-box.svg', page: 'services', commingSoon: true },
                // { name: '{{lang}}insurance', href: '/insurance', key: 'insurance', icon: '/images/icons2/002-wallet.svg', page: 'insurance', commingSoon: true },


                // { name: '{{lang}}services', key: 'services', icon: 'https://www.flaticon.com/svg/static/icons/svg/2055/2055895.svg', page: 'Tower' },
                // { name: '{{lang}}settings', key: 'settings', icon: 'https://www.flaticon.com/svg/static/icons/svg/565/565591.svg', page: 'Tower' },
                // { name: '{{lang}}Edit Thing', href: '/thing/id', key: 'thing', icon: '/images/settings-3.svg', page: 'Tower' },
                // { name: '{{lang}}rigram', href: '/rigram', key: 'regram', icon: '/images/zoom-fit.svg', page: 'Tower' },
                // { name: '{{lang}}addnew', key: 'newService', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'services' },
                // { name: '{{lang}}editService', key: 'editService', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'services' },
                // { name: '{{lang}}removeService', key: 'removeService', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'services' },
                // { name: '{{lang}}addVeryNew', key: 'addVeryNew', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'newService' },

            ],
            tabTree: [],
            selected: 0
        }

    }

    componentDidMount() {


        // let tabTree = []


        // tabs.forEach(tab => {
        //     if (!tab.children) {
        //         tab.children = []
        //     }
        //     if (!tab.parent) {
        //         tabTree.push(tab)
        //     } else {
        //         this.findParent(tabs, tab)
        //     }
        // });

        // console.log(tabTree)
        // this.setState({ tabTree: tabs })
    }










    findParent = (tabs, tab) => {
        tabs.forEach(oneTab => {
            if (oneTab.key == tab.parent) {
                if (!oneTab.children) {
                    oneTab.children = []
                }
                oneTab.children.push(tab)
            }
        });
    }



    changePage = (prop) => {
        this.setState({ selected: prop.key })
        let url = prop.href
        // console.log(prop)
        if (!url) {

            // console.log(this.props.baseUrl)
            url = this.props.baseUrl ? JSON.parse(JSON.stringify(this.props.baseUrl)) : []
            url.push(prop.key)
            // console.log(url)
            url = '/' + url.join('/')
        }

        // console.log(url)
        window.history.pushState({}, '', url);

        // this.props.history.push(pathMaker(url))


    }




    render() {

        // console.log(this.props.options)
        return (

            <div className={"tabBar mobile"} style={{ borderRadius: 10, backgroundColor: '#fff', boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }} onClick={() => this.props.hidePlatform()}>
                <div className="w-100 tabBar-container" style={{ position: 'relative', overflow: 'auto', height: '100%' }}>

                    <div className={'tabsList flex-column d-flex'} style={{}}>

                        {Array.isArray(this.props.options) && this.props.options.map((prop, index) => {

                            let permission = checkPermission(`${this.props.permissionBaseKey}.${prop.key}`, null, this.props.applet)

                            if (!prop.hidePage && (permission || !this.props.permissionBaseKey))
                                return (
                                    <TabBarItem setData={this.props.setData} tabBarOpen={this.props.settings.tabBarOpen} isMobile={this.props.settings.isMobile} data={prop} key={index} index={index} selected={this.state.selected === index} changePage={this.changePage} padding={0} />
                                )
                        })}
                    </div>

                </div>
            </div>

        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(TabBar));

